import { jsx as _jsx } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import { getParcelView } from '../../../../common/network/property';
import { landingRoutes } from '../../../../common/routes';
import E404 from '../../../system/no-layout-404';
import Loading from './loading';
import OrgStoryContent from './org-story-content';
// The standalone screen fetches the parcel the view sits on.
const OrgStoryLoader = (props) => {
    const [viewP] = useFetch(getParcelView(props.story.propertyId));
    const view = usePromise(viewP);
    if (view === undefined)
        return _jsx(Loading, {});
    if (view === null)
        return _jsx(E404, { urlHome: landingRoutes.root.getURL() });
    return _jsx(OrgStoryContent, { story: props.story, view: view });
};
export default OrgStoryLoader;
